import { render, staticRenderFns } from "./DistrictItem.vue?vue&type=template&id=f3d9f45e&scoped=true&"
import script from "./DistrictItem.vue?vue&type=script&lang=js&"
export * from "./DistrictItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d9f45e",
  null
  
)

export default component.exports